import { Pipe, PipeTransform } from '@angular/core';

import { ApplicationService } from '../services/application/application.service';

@Pipe({
    name: 'CollegeName'
})
export class CollegeNamePipe implements PipeTransform {
    constructor(private appService : ApplicationService) { }

    transform(collegeID: number) {
        if (collegeID == null) return '';
        if (!this.appService._AllColleges || !this.appService._AllColleges.length) return '';

        let college = this.appService._AllColleges.find(item => {
            return item.CollegeID == collegeID;
        });

        return (college && college.CollegeName) || '';
    }
}


// WEBPACK FOOTER //
// ./src/pipes/collegename.pipe.ts